import { scrollToGeneralTab } from '../../../common/camps/show/utils';
import { closePopup } from '../../common/popup';

const $ = require('jquery');
window.campSlider = {};
window.campSlider.currentIndex = 0;
let touchStart = {};
let zoomStart = {};
let zooming = false;
let zoomed = false;
let zoomedPrev = { scale: 1, deltaX: 0, deltaY: 0 };
let zoomedData = { scale: 1, deltaX: 0, deltaY: 0 };
let sliding = false;
let closing = false;
let nativeTouch = false;
const NATIVE_CONTROLS_HEIGHT = 64;

const handleOpenSlider = function () {
  const $img = $(this);
  const $images = $img.parents('.for_camp_photo_slider_images').find('img');

  $('.camp_photo_slider__counter_index').html($images.index($img) + 1);
  window.campSlider.currentIndex = $images.index($img);
  $('.camp_photo_slider__counter_total').html($images.length);
  $('.camp_photo_slider__images').html('');
  $images.each(function () {
    const img = $(this);
    const alt = img.data('hide_alt') ? '' : img.attr('alt');
    const isVideo = img.data('media-type') === 'video';

    $('.camp_photo_slider__images').append(`
    <div class="camp_photo_slider__image${isVideo ? ' camp_photo_slider__image_video' : ''}"
         ${isVideo ? `data-video-src="${img.data('video-src')}"` : ''}>
      <img loading="lazy"
           src="${img.attr('src')}"
           alt="${alt}"
           srcset="${img.data('srcset') ?? ''}"
           data-apartment_id="${img.data('apartment_id') ?? ''}"
      />
      ${isVideo ? '<div class="camp_photo_slider__play"></div>' : ''}
    </div>
  `);
  });
  goTo(window.campSlider.currentIndex);
  $('.camp_photo_slider__wrapper').show();

  history.pushState(window.history.state, '', '#mobile_gallery_modal_fullscreen');
  window.openedPopupsIdsStack.push('#mobile_gallery_modal_fullscreen');
};

let tapedRecently = false;
let moved = false;

const handleTouchstart = (e) => {
  const event = e.originalEvent;
  const target = $('.camp_photo_slider__images_wrapper img').eq(window.campSlider.currentIndex)[0];
  touchStart = { x: event.touches[0].screenX, y: event.touches[0].screenY };

  if (isVideoSlide(window.campSlider.currentIndex)) {
    moved = false;
    return;
  }

  if (event.touches.length === 2) {
    zoomStart = {
      x: (event.touches[0].pageX + event.touches[1].pageX) / 2,
      y: (event.touches[0].pageY + event.touches[1].pageY) / 2,
      distance: Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY
      ),
    };
  } else {
    if (tapedRecently && !moved && !sliding) {
      tapedRecently = false;
      if (zoomed) {
        target.style.transform = '';
        target.style.transition = '.3s';
        setTimeout(() => {
          target.style.transition = '';
        }, 400);
        zoomedPrev = { scale: 1, deltaX: 0, deltaY: 0 };
        zoomedData = { scale: 1, deltaX: 0, deltaY: 0 };
        zooming = false;
        zoomed = false;
      } else {
        target.style.transform = `translate3d(0, 0, 0) scale(${2})`;
        target.style.transition = '.3s';
        setTimeout(() => {
          target.style.transition = '';
        }, 400);
        zoomedPrev = { scale: 2, deltaX: 0, deltaY: 0 };
        zoomedData = { scale: 2, deltaX: 0, deltaY: 0 };
        zooming = false;
        zoomed = true;
      }
    } else {
      tapedRecently = true;
      moved = false;
      setTimeout(() => {
        tapedRecently = false;
      }, 300);
    }
  }
};

const handleTouchmove = (e) => {
  const event = e.originalEvent;
  if (event.touches.length === 2) {
    if (isVideoSlide(window.campSlider.currentIndex)) return;
    // Зум
    event.preventDefault(); // Prevent page scroll
    zooming = true;

    // Safari provides event.scale as two fingers move on the screen
    // For other browsers just calculate the scale manually
    let scale;
    if (event.scale) {
      scale = event.scale;
    } else {
      const deltaDistance = Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY
      );
      scale = deltaDistance / zoomStart.distance;
    }

    scale *= zoomedPrev.scale;

    let imageElementScale = Math.min(Math.max(1, scale), 3);

    // Calculate how much the fingers have moved on the X and Y axis
    let deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - zoomStart.x) * 2; // x2 for accelarated movement
    let deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - zoomStart.y) * 2; // x2 for accelarated movement
    const target = $('.camp_photo_slider__images_wrapper img').eq(window.campSlider.currentIndex)[0];

    deltaX = limitZoomDiffX(deltaX);
    deltaX += zoomedPrev.deltaX;
    zoomedData.deltaX = deltaX;
    deltaY += zoomedPrev.deltaY;
    deltaY = limitZoomDiffY(deltaY, target);
    zoomedData.deltaY = deltaY;
    deltaX = limitZoomDiffX(deltaX);
    zoomedData.scale = imageElementScale;

    // Transform the image to make it grow and move with fingers
    target.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
  } else if (!zooming && !zoomed) {
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;

    if (Math.abs(touchEndX - touchStart.x) > 10 || Math.abs(touchEndY - touchStart.y) > 10) {
      moved = true;
    }

    if (sliding || (Math.abs(touchEndX - touchStart.x) > 30 && !closing)) {
      // Перемотка

      sliding = true;
      let diff = touchEndX - touchStart.x;
      diff = diff < 0 ? diff + 30 : diff - 30;
      const diffPercent = diff / window.innerWidth;
      $('.camp_photo_slider__images').css(
        'transform',
        `translate(-${100 * (window.campSlider.currentIndex - diffPercent)}vw, 0)`
      );
    } else if (closing || (touchEndY - touchStart.y > 30 && !sliding)) {
      // Закрытие

      closing = true;
      let diff = Math.max(0, touchEndY - touchStart.y - 30);
      const img = $(getSlideTarget(window.campSlider.currentIndex));
      img.css('transform', `translate(0, ${diff}px)`);
      img.css('opacity', 1 - (diff / window.innerHeight) * 3);
    }
  } else if (!zooming && zoomed) {
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;
    let diffX = touchEndX - touchStart.x;
    let diffY = touchEndY - touchStart.y;
    const target = $('.camp_photo_slider__images_wrapper img').eq(window.campSlider.currentIndex)[0];

    diffX += zoomedPrev.deltaX;

    diffX = limitZoomDiffX(diffX);
    diffY += zoomedPrev.deltaY;
    diffY = limitZoomDiffY(diffY, target);
    zoomedData.deltaX = diffX;
    zoomedData.deltaY = diffY;
    // Transform the image to make it grow and move with fingers
    target.style.transform = `translate3d(${diffX}px, ${diffY}px, 0) scale(${zoomedPrev.scale})`;
  }
};

const limitZoomDiffX = (diff) => {
  diff = Math.min(diff, (window.innerWidth * zoomedPrev.scale - window.innerWidth) / 2);
  diff = Math.max(diff, -(window.innerWidth * zoomedPrev.scale - window.innerWidth) / 2);
  return diff;
};

const limitZoomDiffY = (diff, target) => {
  if (target.clientHeight * zoomedPrev.scale < window.innerHeight) {
    return diff;
  } else {
    diff = Math.min(diff, (target.clientHeight * zoomedPrev.scale - window.innerHeight) / 2);
    diff = Math.max(diff, -(target.clientHeight * zoomedPrev.scale - window.innerHeight) / 2);
    return diff;
  }
};

const handleTouchend = (e) => {
  const target = getSlideTarget(window.campSlider.currentIndex);

  zoomedPrev.deltaX = zoomedData.deltaX;
  zoomedPrev.deltaY = zoomedData.deltaY;

  const $slide = getSlides().eq(window.campSlider.currentIndex);
  if ($slide.hasClass('camp_photo_slider__image_video') && !sliding && !closing && !moved) {
    toggleVideo($slide);
  }

  if (zooming) {
    if (e.originalEvent.touches.length === 0) {
      zooming = false;
      zoomed = true;
      zoomedPrev.scale = zoomedData.scale;
      if (zoomedPrev.scale <= 1.2) {
        zoomedData = { scale: 1, deltaX: 0, deltaY: 0 };
        zoomedPrev = { scale: 1, deltaX: 0, deltaY: 0 };
        zoomed = false;
        target.style.transform = '';
      }
    }
    return;
  }

  if (sliding) {
    // Перемотка
    const touchEndX = e.originalEvent.changedTouches[0].screenX;
    if (Math.abs(touchEndX - touchStart.x) > 50) {
      if (touchEndX < touchStart.x) {
        if (window.campSlider.currentIndex < $('.camp_photo_slider__images img').length - 1) {
          window.campSlider.currentIndex += 1;
        }
      }

      if (touchEndX > touchStart.x) {
        if (window.campSlider.currentIndex > 0) {
          window.campSlider.currentIndex -= 1;
        }
      }
    }
  } else if (closing) {
    // Закрытие
    target.style.opacity = 1;
    target.style.transform = '';
    const touchEndY = e.originalEvent.changedTouches[0].screenY;
    let diff = touchEndY - touchStart.y;
    if (diff > window.innerHeight / 4) {
      handleClose();
    }
  }

  goTo(window.campSlider.currentIndex);

  sliding = false;
  closing = false;
};

const initCampPhotoSliders = ($wrapper = null) => {
  if ($wrapper) {
    $wrapper.find('.for_camp_photo_slider_images img').off('click', handleOpenSlider).on('click', handleOpenSlider);
  } else {
    $('.for_camp_photo_slider_images img').off('click', handleOpenSlider).on('click', handleOpenSlider);
  }

  if (!$wrapper) {
    $('.camp_photo_slider__close').on('click', function (e) {
      e.preventDefault();
      handleClose();
    });

    $('.camp_photo_slider__images_wrapper')
      .off('touchstart.campSlider')
      .on('touchstart.campSlider', function (e) {
        nativeTouch = isNativeControlsTouch(e.originalEvent);
        if (nativeTouch) return;
        e.preventDefault();
        handleTouchstart(e);
      })
      .off('touchmove.campSlider')
      .on('touchmove.campSlider', function (e) {
        if (!nativeTouch) handleTouchmove(e);
      })
      .off('touchend.campSlider')
      .on('touchend.campSlider', function (e) {
        if (nativeTouch) {
          nativeTouch = false;
          return;
        }
        handleTouchend(e);
      });
  }

  window.addEventListener('popstate', close);
};

const goTo = (index) => {
  pauseVideosExcept(index);

  setTimeout(() => releaseVideosExcept(window.campSlider.currentIndex), 300);

  $('.camp_photo_slider__images').css('transition', '.3s');
  $('.camp_photo_slider__images').css('transform', `translate(-${100 * index}vw, 0)`);
  setTimeout(() => {
    $('.camp_photo_slider__images').css('transition', '.01s');
  }, 300);
  $('.camp_photo_slider__counter_index').html(index + 1);
  const description = $('.camp_photo_slider__images_wrapper img').eq(index).attr('alt');
  const apartment_id = $('.camp_photo_slider__images_wrapper img').eq(index).data('apartment_id');
  if (apartment_id > 0) {
    $('.camp_photo_slider__description')
      .html(
        `
      <div>${description}</div>
      <a class="camp_photo_slider__apartment_btn">К номеру</a>
    `
      )
      .show();
    $('.camp_photo_slider__apartment_btn').click(() => {
      handleClose();
      closePopup('mobile_gallery_modal');
      setTimeout(() => {
        scrollToGeneralTab($(`#apartment-${apartment_id}`));
        window.open_link_photo = $(this).hasClass('link-from-photo');
      }, 0);
    });
  } else if (description?.length > 0) {
    $('.camp_photo_slider__description').html(description).show();
  } else {
    $('.camp_photo_slider__description').hide();
  }
};

const handleClose = () => {
  close();
  history.back();
};

const close = () => {
  getSlides().each(function () {
    releaseVideo($(this));
  });

  zoomedData = { scale: 1, deltaX: 0, deltaY: 0 };
  zoomedPrev = { scale: 1, deltaX: 0, deltaY: 0 };
  zoomed = false;
  zooming = false;
  $('.camp_photo_slider__wrapper').hide();
};

const getSlides = () => {
  return $('.camp_photo_slider__images .camp_photo_slider__image');
};

const isVideoSlide = (index) => getSlides().eq(index).hasClass('camp_photo_slider__image_video');

const getSlideTarget = (index) => {
  const $slide = getSlides().eq(index);
  return $slide.hasClass('camp_photo_slider__image_video') ? $slide[0] : $slide.find('img')[0];
};

const ensureVideo = ($slide) => {
  let video = $slide.find('video')[0];

  if (video) {
    return video;
  }

  video = document.createElement('video');
  video.setAttribute('playsinline', '');
  video.preload = 'metadata';
  video.poster = $slide.find('img').attr('src');
  video.src = $slide.data('video-src');
  video.addEventListener('play', () => $slide.addClass('is-playing'));
  video.addEventListener('pause', () => $slide.removeClass('is-playing'));
  video.addEventListener('ended', () => $slide.removeClass('is-playing'));
  $slide.append(video);
  return video;
};

const toggleVideo = ($slide) => {
  const video = ensureVideo($slide);
  if (video.paused) {
    video.controls = true;
    video.play().catch(() => {});
  } else {
    video.pause();
  }
};

const pauseVideosExcept = (index) => {
  getSlides().each(function (i) {
    if (i === index) return;
    const video = $(this).find('video')[0];
    if (video) {
      video.pause();
    }
  });
};

const releaseVideo = ($slide) => {
  const video = $slide.find('video')[0];
  if (!video) return;

  video.pause();
  video.removeAttribute('src');
  video.load();
  video.remove();
  $slide.removeClass('is-playing');
};

const releaseVideosExcept = (index) => {
  getSlides().each(function (i) {
    if (i !== index) releaseVideo($(this));
  });
};

const isNativeControlsTouch = (event) => {
  const video = $(event.target).closest('video')[0];
  if (!video || !video.controls) return false;
  return video.getBoundingClientRect().bottom - event.touches[0].clientY < NATIVE_CONTROLS_HEIGHT;
};

export { initCampPhotoSliders };
